

import {useState,useEffect} from 'react'
import { Link ,useLocation,useSearchParams} from 'react-router-dom'
import { Cookies,useCookies } from 'react-cookie';
import { Helmet, HelmetProvider } from "react-helmet-async";
import { direct } from '../Services/Service';


const TncPublic = () => {
  // const {tran} = useLocation().state;
    const [resdata,setRespdata] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  let skuid = searchParams.get("skuid")
    // console.log(tran)
    useEffect(()=>{
      direct(skuid).then(res=>{
        setRespdata(res.data.data.description)
     }).catch((err) => console.log(err.message));
    },[])

    return (
      <div className="content-apps">
      <HelmetProvider>
        <Helmet>
          <title>Thankyou</title>
        </Helmet>
      </HelmetProvider>
      <section className="">
      {/* <div className="circleblurbg"></div> */}
      <div className="container px-4">
          <div className="row align-items-center py-2 payment-success">
              <div className="col-12 text-center">
              <p>{skuid}</p>
    <p>{resdata}</p>
                  {/* <h4>{tran}</h4> */}
                  <div className='rowGap10'/>
                  {/* <Link to="/orders"><button type="button" className="btn btn-outline-secondary btn-track-order-status mb-3">Track Order Status</button></Link>
                  <Link to = "/home"><button type="button" className="btn btn-outline-secondary btn-back-to-home">Back to Home</button></Link> */}
              </div>
          </div>
      </div>
  </section>
  </div>
    )
  }


export default TncPublic;
